<template>
    <b-form-group label="" v-slot="{ ariaDescribedby }">
        <b-form-radio-group
            id="radio-group-2"
            v-model="selectedRange"
            :aria-describedby="ariaDescribedby"
            name="DateRangeSelector"
        >
            <b-form-radio :value="0">Today</b-form-radio>
            <b-form-radio :value="1">Yesterday</b-form-radio>
            <b-form-radio disabled :value="2">Custom</b-form-radio>
        </b-form-radio-group>
    </b-form-group>
</template>
<script>
export default {
    data() {
        return {
            selectedRange: 2,
        }
    },
    props: ['value'],
    watch: {
        value: function (val) {
            this.selectedRange = val
        },
        selectedRange: function (val) {
            this.$emit('input', val)
        },
    },
    mounted() {
        this.selectedRange = this.value
    },
}
</script>